import React, {useEffect, useState} from "react";
import InboxTable from './InboxTable'
import { OBPSService } from '../../../../../../../libraries/src/services/elements/OBPS';


function PaymentDetails({type}) {
    const tenantId = Digit.ULBService.getCurrentTenantId();
    const [apiData, setApiData] = useState(null);

    const fetchData = async () => {
      const result = await OBPSService.paymentReportData();
      setApiData(result);
    };
    
      useEffect(async () => {
       await fetchData()
      }, [])
    return(
            <InboxTable apiData={apiData} />
    )
}

export default PaymentDetails